import { __makeTemplateObject } from '../../../../_virtual/_tslib.js';
import styled from 'styled-components';
var PriceStripe = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  padding: 0 ", "px;\n  width: fit-content;\n"], ["\n  background-color: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  padding: 0 ", "px;\n  width: fit-content;\n"])), function (_a) {
  var backgroundColor = _a.backgroundColor;
  return backgroundColor;
}, function (_a) {
  var fontColor = _a.fontColor;
  return fontColor;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.typography) === null || _b === void 0 ? void 0 : _b.type.primary;
}, function (_a) {
  var fontSize = _a.fontSize;
  return fontSize;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.typography) === null || _b === void 0 ? void 0 : _b.weight.bold;
}, function (_a) {
  var _b;

  var theme = _a.theme;
  return (_b = theme.spacings) === null || _b === void 0 ? void 0 : _b.xxs;
});
var templateObject_1;
export { PriceStripe };